module.exports = window.jQuery;


//////////////////
// WEBPACK FOOTER
// external "window.jQuery"
// module id = 5
// module chunks = 62